<template>
  <v-container class="page">
    <table>
      <thead>
        <tr>
          <td>
            <div
              class="cointainer caption"
              style="display: flex; justify-content: flex-end"
            >
              <div class="left-cointainer">
                <img
                  height="50"
                  class="mt-1"
                  contain
                  src="/static/img/Logo MM.png"
                />
              </div>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <p align="center">
              <strong>REGULAMIN KADRY OBOZOWEJ MUSIC &amp; MORE</strong>
            </p>
            <p>
              Regulamin dotyczy wszystkich rodzajów funkcji, które Kadra pełni w
              trakcie obozów: wychowawca, instruktor, pomoc techniczna oraz
              osoba odpowiedzialna za fotorelację. Kadra jest odpowiedzialna
              przede wszystkim za życie, zdrowie i bezpieczeństwo uczestników
              obozów i bierze za te aspekty pełną odpowiedzialność od momentu
              przyjazdu na obóz do momentu wyjazdu każdego z uczestników.
            </p>

            <h3 align="center">
              §1 Obowiązki Kadry (dotyczy każdej z funkcji)
            </h3>
            <ol>
              <li>
                Znajomość i systematyczne przestrzeganie zasad oraz przepisów
                bezpieczeństwa i higieny pracy.
              </li>
              <li>
                Przestrzeganie reżimu sanitarnego dotyczącego zasad bezpiecznego
                funkcjonowania w trakcie epidemii COVID - 19.
              </li>
              <li>
                Znajomość wszystkich dokumentów obowiązujących podczas
                wypoczynku (regulaminy, przepisy, zarządzenia, instrukcje, plan
                pracy, standardy firmy) oraz stosowanie się do nich.
              </li>
              <li>Sumienne i rzetelne wykonywanie pracy.</li>
              <li>
                Prowadzenie zajęć ogólnocampowych, organizacja gier i zabaw dla
                grup dzieci, w czasie wyznaczonym przez Kierownika wypoczynku.
              </li>
              <li>
                Prowadzenie animacji podczas wydarzeń specjalnych, np.
                dyskoteki.
              </li>
              <li>
                Sprawowanie opieki nad uczestnikami w zakresie ich
                bezpieczeństwa, wyglądu, higieny, zdrowia i wychowania.
                <ol>
                  <li>
                    Kontrola zaopatrzenia uczestników w odpowiednią odzież i
                    sprzęt zapewniający bezpieczeństwo w czasie realizacji zajęć
                    i kąpieli.
                  </li>
                  <li>
                    Kontrola wyposażenia i stanu urządzeń technicznych,
                    instalacji, sprzętu.
                  </li>
                  <li>
                    Usunięcie wszelkich dostrzeżonych braków i usterek, jeżeli
                    usunięcie ich we własnym zakresie jest możliwe. Niezwłoczne
                    zgłaszanie kierownikowi Campu o wszelkich spostrzeżeniach
                    dotyczących braków i błędów zagrażających zdrowiu i życiu
                    dzieci.
                  </li>
                  <li>
                    Natychmiastowe przerwanie zajęć, gdy stan terenu, budynku,
                    pomieszczenia, sprzętu, instalacji, materiału zagraża
                    uczestnikom, pracownikom lub innym osobom.
                  </li>
                  <li>
                    Kontrola przestrzegania przez uczestników obowiązujących
                    regulaminów zajęć, zachowania, oraz nadzór i czujność
                    podczas podróży, zajęć, ćwiczeń, wycieczek, kąpieli i
                    plażowania.
                  </li>
                  <li>
                    Nadzór, by dziecko nie oddalało się od grupy, nie wychodziło
                    poza teren ośrodka.
                  </li>
                  <li>
                    Obserwowanie czy nie jest naruszana cielesność dziecka
                    (przemoc fizyczna – bicie, szczypanie, szturchanie;
                    dotykanie przez innych).
                  </li>
                  <li>
                    Interwencja w przypadku zgłoszenia wystąpienia przemocy
                    psychicznej lub fizycznej.
                  </li>
                  <li>
                    Natychmiastowe udzielenie lub zapewnienie uczestnikowi
                    pierwszej pomocy i dalszej opieki w razie nieszczęśliwego
                    wypadku, powiadomienie o wypadku kierownika wypoczynku,
                    przeciwdziałanie ujemnym skutkom wypadku i podjęcie innych
                    niezbędnych środków.
                  </li>
                  <li>
                    Sprawdzanie liczby uczestników w grupie przed i po zajęciach
                    a także w uzasadnionych przypadkach podczas zajęć. W
                    przypadku zauważania braku podopiecznego podjęcie
                    odpowiednich kroków.
                  </li>
                  <li>
                    Wykonywanie zadań w oparciu o dążenie do pełnej akceptacji i
                    aktywizacji uczestników.
                  </li>
                  <li>
                    Dążenie, by dzieci wracały z obozów Music &amp; More z
                    nowymi umiejętnościami, bardziej samodzielne, empatyczne,
                    otwarte, zdyscyplinowane, odważne itp.
                  </li>
                  <li>
                    Przeciwdziałanie dyskryminacji ze względu na płeć, wiek,
                    niepełnosprawność, rasę lub pochodzenie etniczne, wyznanie.
                  </li>
                </ol>
              </li>
              <li>
                Współdziałanie z kierownikiem wypoczynku w zakresie realizacji
                programu.
              </li>
              <li>
                Organizowanie zajęć w oparciu o dążenie do pełnej akceptacji i
                aktywizacji uczestników.
              </li>
              <li>Prowadzenie zajęć zgodnie z poleceniami kierownika.</li>
              <li>
                Pomoc prowadzącym zajęcia programowe w zakresie organizacji i
                realizacji programu oraz w dbaniu o porządek i dyscyplinę.
              </li>
              <li>
                Podczas zajęć ogólnocampowych: pomoc w organizacji, dbanie o
                porządek i dyscyplinę, stosowanie się do uwag i poleceń osób
                prowadzących dane zajęcia, aktywne uczestnictwo od początku do
                końca ich trwania.
              </li>
              <li>
                Na prośbę kierownika obozu sprawowanie opieki i zapewnienie
                bezpieczeństwa uczestnikom przebywającym na terenie basenu
                (akwenu wodnego) lub na innym terenie, na którym odbywają się
                zajęcia . Za bezpieczeństwo w wodzie odpowiada ratownik – z
                wyłączeniem pobytu na basenie kwalifikowanym jako basen
                ogrodowy.
              </li>
              <li>
                Informowanie kierownika wypoczynku o wszystkich nadzwyczajnych
                wydarzeniach i obserwacjach.
              </li>
              <li>
                Aktywny udział we wszystkich aktywnościach obozowych (w ramach
                wyznaczonych obowiązków).
              </li>
              <li>
                Dbałość o powierzony sprzęt i opiekowanie się nim zgodnie z
                zaleceniami Kierownika (np. każdorazowa dezynfekcja).
              </li>
              <li>
                W razie potrzeby udzielenie pierwszej pomocy podopiecznym lub
                współpracownikom oraz powiadomienia odpowiednich służb.
              </li>
              <li>
                Na polecenie Organizatora uczestniczenie w transporcie grup i
                odpowiadanie za bezpieczeństwo dzieci podczas przewozu. Zasady
                opieki podczas transportu określa osobny dokument – Wytyczne dla
                Kadry Przewozowej.
              </li>
              <li>
                Zachowanie wysokiej kultury osobistej i kultury słowa. Bycie
                wzorem naśladowania dla uczestników.
              </li>
              <li>
                Kadra jest odpowiedzialna za wszystkich uczestników obozów oraz
                przede wszystkich za ich życie, zdrowie i bezpieczeństwo.
              </li>
              <li>Wykonywanie poleceń Kierownika wypoczynku.</li>
            </ol>

            <h3 align="center">§2 Obowiązki Wychowawcy</h3>
            <ol>
              <li>
                Znajomość wszystkich dokumentów obowiązujących podczas
                wypoczynku (regulaminy, przepisy, zarządzenia, instrukcje, plany
                pracy, standardy firmy) oraz stosowanie się do nich. Sumienne i
                rzetelne wykonywanie pracy.
              </li>
              <li>Sumienne i rzetelne wykonywanie pracy.</li>
              <li>
                Sprawowanie opieki nad uczestnikami w zakresie ich
                bezpieczeństwa, wyglądu, higieny, zdrowia i wychowania.
              </li>
              <b>Bezpieczeństwo</b>
              <ol>
                <li>
                  Znajomość i systematyczne przestrzeganie zasad oraz przepisów
                  bezpieczeństwa i higieny pracy.
                </li>
                <li>
                  Kontrola miejsc zajęć uczestników (terenu, budynku,
                  pomieszczeń) oraz dróg do nich prowadzących, w szczególności
                  sprawdzenie, czy ich aktualny stan odpowiada wymogom oraz
                  przepisom z zakresu bezpieczeństwa i higieny.
                </li>
                <li>
                  Kontrola zaopatrzenia uczestników w odpowiednią odzież i
                  sprzęt zapewniający bezpieczeństwo w czasie realizacji zajęć
                  programowych, wycieczek i kąpieli.
                </li>
                <li>
                  Kontrola wyposażenia i stanu urządzeń technicznych,
                  instalacji, sprzętu.
                </li>
                <li>
                  Usunięcie wszelkich dostrzeżonych braków i usterek, jeżeli
                  usunięcie ich we własnym zakresie jest możliwe. Niezwłoczne
                  zgłaszanie kierownikowi Campu wszelkich spostrzeżonych braków
                  i błędów zagrażających zdrowiu i życiu dzieci.
                </li>
                <li>
                  Natychmiastowe przerwanie zajęć, gdy stan terenu, budynku,
                  pomieszczenia, sprzętu, instalacji, materiału zagraża
                  uczestnikom, pracownikom lub innym osobom.
                </li>
                <li>
                  Kontrola przestrzegania przez uczestników obowiązujących
                  regulaminów zajęć, zachowania, oraz nadzór i czujność podczas
                  podróży, zajęć, ćwiczeń, wycieczek, kąpieli i plażowania.
                </li>
                <li>
                  Obserwowanie podopiecznych podczas posiłków – kontrola czy
                  umiejętnie korzystają ze sztućców, naczyń, czy nie grozi im
                  poparzenie herbatą, zupą itp.
                </li>
                <li>
                  Nadzór, by dziecko nie oddalało się od grupy, nie wychodziło
                  poza teren ośrodka.
                </li>
                <li>
                  Obserwowanie czy nie jest naruszana cielesność dziecka
                  (przemoc fizyczna – bicie, szczypanie, szturchanie; dotykanie
                  przez innych).
                </li>
                <li>
                  Kontrola stanu emocjonalnego i bezpieczeństwa psychicznego
                  dziecka (tęsknota, brak samodzielności, niskie poczucie
                  własnej wartości, przemoc psychiczna ze strony innych
                  uczestników – wyśmiewanie, zastraszanie, dręczenie).
                </li>
                <li>
                  Interwencja w przypadku zgłoszenia wystąpienia przemocy
                  psychicznej lub fizycznej.
                </li>
                <li>
                  Pilna interwencja w przypadku zgłoszenia przez dziecko myśli
                  samobójczych, zgłoszenie faktu do kierownika Campu.
                </li>
                <li>
                  Natychmiastowe udzielenie lub zapewnienie uczestnikowi
                  pierwszej pomocy i dalszej opieki w razie nieszczęśliwego
                  wypadku, powiadomienie o wypadku kierownika wypoczynku,
                  przeciwdziałanie ujemnym skutkom wypadku i podjęcie innych
                  niezbędnych środków.
                </li>
              </ol>
              <b>Zdrowie</b>
              <ol>
                <li>
                  Zapoznanie się z kartą kwalifikacyjną uczestnika oraz
                  pozostałymi dokumentami dotyczącymi stanu zdrowia dziecka.
                </li>
                <li>
                  Zapoznanie się ze stanem zdrowia wszystkich dzieci ze swojej
                  grupy wychowawczej.
                </li>
                <li>Ścisła współpraca z lekarzem i higienistką.</li>
                <li>Monitorowanie stanu zdrowia i samopoczucia dzieci.</li>
                <li>
                  Codzienne przypominanie o sprawdzeniu swojego ciała pod kątem
                  np. kleszczy (na Campach letnich).
                </li>
                <li>Codziennie przypominanie o piciu wody.</li>
                <li>
                  Przypominanie o smarowaniu się kremem z filtrem przed każdym
                  wyjściem na słońce oraz po kąpieli w akwenie.
                </li>
                <li>Nadzór nad zażywaniem leków.</li>
                <li>
                  Przestrzeganie reżimu sanitarnego dotyczącego zasad
                  bezpiecznego funkcjonowania w trakcie epidemii COVID - 19.
                </li>
              </ol>
              <b>Higiena</b>
              <ol>
                <li>
                  Codzienna kontrola higieny osobistej dziecka – szczotkowanie
                  zębów dwa razy dziennie, mycie włosów, mycie całego ciała,
                  dezynfekcja i/lub mycie rąk przed posiłkiem i po powrocie z
                  zajęć.
                </li>
                <li>
                  Kontrola środków utrzymywania higieny osobistej w łazience –
                  obecność papieru toaletowego, mydła do rąk, suszenie
                  ręczników.
                </li>
                <li>
                  Kontrola stanu skóry głowy (czystość, obecność pasożytów) oraz
                  ciała (w zakresie widoczności) podopiecznych.
                </li>
                <li>
                  Nauka utrzymywania porządku – ścielenie łóżka, używanie
                  środków utrzymania czystości (szczotka, odkurzacz, mop,
                  szmatka do podłogi w łazience).
                </li>
                <li>
                  Nadzór nad separowaniem brudnych ubrań, suszeniem mokrej
                  odzieży, utrzymywaniem w czystości i porządku łóżek, walizek,
                  szaf, szafek osobistych.
                </li>
                <li>
                  Po powrocie z zajęć wodnych dopilnowanie rozwieszenia mokrej
                  odzieży, ręczników, wysuszenia włosów.
                </li>
                <li>Nadzór nad tym, by podopieczni zmieniali odzież.</li>
              </ol>
              <b>Wygląd</b>
              <ol>
                <li>
                  Kontrola schludnego wyglądu podopiecznych i ubioru adekwatnego
                  do pogody oraz okoliczności.
                </li>
                <li>
                  W razie potrzeby pomoc przy myciu i rozczesywaniu włosów,
                  ubieraniu się.
                </li>
              </ol>
              <b>Wychowanie</b>
              <ol>
                <li>
                  Rozwiązanie na bieżąco problemów wychowawczych, w razie
                  potrzeby zgłaszanie ich do przełożonego.
                </li>
                <li>
                  Dążenie, by dzieci wracały z obozów Music &amp; More z nowymi
                  umiejętnościami, bardziej samodzielne, empatyczne, otwarte,
                  zdyscyplinowane, odważne itp.
                </li>
                <li>
                  Przeciwdziałanie dyskryminacji ze względu na płeć, wiek,
                  niepełnosprawność, rasę lub pochodzenie etniczne, wyznanie.
                </li>
              </ol>
              <li>
                Pełnienie funkcji opiekuna dzieci, zastępowanie im rodziców.
                Organizowanie i prowadzenie zajęć.
                <ol>
                  <li>
                    Przechowywanie telefonów i innych sprzętów elektronicznych
                    dzieci ze swojej grupy oraz wydawanie sprzętu zgodnie z
                    ustalonymi zasadami.
                  </li>
                  <li>
                    W razie potrzeby prowadzenie depozytu pieniężnego dzieci ze
                    swojej grupy wychowawczej i dysponowanie środkami zgodnie z
                    zaleceniem rodziców/opiekunów.
                  </li>
                  <li>
                    Organizacja zbiórki swojej grupy przed każdym posiłkiem,
                    aktywnością grupową, wyjściem.
                  </li>
                  <li>
                    Pilnowanie porządku podczas i po posiłku (ciche wsuwanie
                    krzeseł, zachowanie ciszy podczas spożywanie posiłków,
                    odnoszenie brudnych naczyń).
                  </li>
                  <li>
                    Przeprowadzanie rozruchu porannego (w ramach wyznaczonych
                    obowiązków).
                  </li>
                  <li>
                    Sprawdzanie porządku podczas ciszy poobiedniej oraz podczas
                    ciszy nocnej.
                  </li>
                  <li>
                    Zgaszenie światła o określonej godzinie w pokojach swoich
                    podopiecznych.
                  </li>
                  <li>
                    Kontrola czy każdy w pokoju ma zapewnioną przestrzeń do
                    trzymania swoich rzeczy.
                  </li>
                  <li>
                    Współdziałanie z kierownikiem wypoczynku w zakresie
                    realizacji programu.
                  </li>
                  <li>
                    Organizowanie zajęć w oparciu o dążenie do pełnej akceptacji
                    i aktywizacji uczestników.
                  </li>
                  <li>
                    Pomaganie w organizacji wyjścia dzieci na zajęcia
                    (odpowiedni ubiór, higiena osobista itd.).
                  </li>
                  <li>
                    Ustalenie reguł współżycia w grupie, określenie obowiązków
                    poszczególnych osób.
                  </li>
                  <li>
                    Sprawdzanie liczby uczestników w grupie przed i po zajęciach
                    a także w uzasadnionych przypadkach podczas zajęć. W
                    przypadku zauważania braku podopiecznego podjęcie
                    odpowiednich kroków.
                  </li>
                  <li>
                    Prowadzenie zajęć pozaprogramowych zgodnie z poleceniami
                    kierownika.
                  </li>
                  <li>
                    Podczas zajęć ogólnocampowych: pomoc w organizacji, dbanie o
                    porządek i dyscyplinę, stosowanie się do uwag i poleceń osób
                    prowadzących dane zajęcia, aktywne uczestnictwo od początku
                    do końca ich trwania.
                  </li>
                  <li>
                    Na prośbę kierownika obozu sprawowanie opieki i zapewnienie
                    bezpieczeństwa uczestnikom przebywającym na terenie basenu
                    lub akwenu. Za bezpieczeństwo w wodzie odpowiada ratownik –
                    z wyłączeniem pobytu na basenie kwalifikowanym jako basen
                    ogrodowy.
                  </li>
                  <li>
                    W razie potrzeby wnioskowanie o usunięcie z wypoczynku
                    dzieci jawnie naruszających i regulamin Campu i nie
                    stosujących się do ogólnie przyjętych zasad.
                  </li>
                </ol>
              </li>
              <li>
                Informowanie Kierownika o wszystkich nadzwyczajnych wydarzeniach
                i obserwacjach.
              </li>
              <li>
                Aktywny udział we wszystkich aktywnościach obozowych (w ramach
                wyznaczonych obowiązków).
              </li>
              <li>
                Dbałość o powierzony sprzęt i opiekowanie się nim zgodnie z
                zaleceniami Kierownika (np. każdorazowa dezynfekcja).
              </li>
              <li>
                Sprawdzenie pokoi po wykwaterowaniu, zebranie pozostawionych
                rzeczy, wydanie ich podopiecznym lub opisanie i przekazanie
                kierownikowi/kierowniczce podróży.
              </li>
              <li>
                W pierwszym i ostatnim dniu wykonanie zadań zgodnie z przekazaną
                przez Kierownika check-listą i zdanie raportu o ich wykonaniu.
              </li>
              <li>
                W razie potrzeby udzielenie pierwszej pomocy podopiecznym lub
                współpracownikom oraz powiadomienia odpowiednich służb.
              </li>
              <li>
                Na polecenie Organizatora uczestniczenie w transporcie grup i
                odpowiadanie za bezpieczeństwo dzieci podczas przewozu. Zasady
                opieki podczas transportu określa osobny dokument – Wytyczne dla
                Kadry Przewozowej.
              </li>
              <li>
                Prowadzenie dziennika zajęć swojej grupy oraz wymaganej
                dokumentacji zgodnie z zaleceniami Kierownika wypoczynku.
              </li>
              <li>
                Zachowanie wysokiej kultury osobistej i kultury słowa. Bycie
                wzorem naśladowania dla uczestników i uczestniczek.
              </li>
              <li>Wykonywanie poleceń Kierownika wypoczynku.</li>
            </ol>

            <h3 align="center">§3 Obowiązki Instruktora</h3>
            <ol>
              <li>
                Pełnienie funkcji nauczyciela w ramach określonego programu i
                obozu.
              </li>
              <li>
                Dbałość o bezpieczeństwo i zdrowie uczestników, szczególnie w
                przypadku obozów o podwyższonym ryzyku.
              </li>
              <li>
                Wdrażanie programów w roli instruktora zgodnie z Zasadami:
                <ol type="a">
                  <li>ambitnie,</li>
                  <li>zespołowo,</li>
                  <li>na zawsze</li>
                </ol>
              </li>
              <li>
                Dokładne zapoznanie się z przygotowanym przez Organizatora
                programem co najmniej na tydzień przed planowanym startem
                pierwszego turnusu.
              </li>
              <li>
                Przeprowadzenie zajęć w ramach obozu tematycznego zgodnie z
                programem. Ewentualne zmiany w programach lub harmonogramie
                obozu wymaga każdorazowej akceptacji Kierownika.
              </li>
              <li>
                Dbałość o sprzęt przygotowany do przeprowadzenia zajęć w ramach
                obozu oraz o pozostały sprzęt przygotowany przez Organizatora.
              </li>
              <li>
                Przygotowanie się do zajęć najpóźniej na 30 minut przed ich
                startem:
                <ol type="a">
                  <li>
                    przygotowanie sprzętu oraz szczegółowego planu na dany dzień
                    zajęć,
                  </li>
                  <li>
                    przygotowanie sali lub otoczenia do prowadzenia zajęć.
                  </li>
                </ol>
              </li>
              <li>
                Staranne i terminowe (bez opóźnień) prowadzenie zajęć:
                <ol type="a">
                  <li>rozpoczęcie zajęć od zbiórki i przywitania,</li>
                  <li>
                    realizacja zajęć zgodnie z harmonogramem na każdy dzień,
                  </li>
                  <li>zakończenie każdego bloku zajęciowego,</li>
                  <li>odłożenie sprzętu w wyznaczone miejsca,</li>
                  <li>
                    oddanie dzieci realizujących program pod opiekę wyznaczonego
                    wychowawcy zgodnie ze szczegółowymi wytycznymi Kierownika.
                  </li>
                </ol>
              </li>
              <li>Przygotowanie sprzętu i programu na następny dzień.</li>
              <li>
                W przypadku prowadzenia obozów o podwyższonym ryzyku dla
                uczestnika, takich jak obozy konne, żeglarskie, narciarskie,
                snowboardowe, militarne, rejsy - instruktor jest zobowiązany do
                przestrzegania dodatkowych wewnętrznych reguł organizacji oraz
                bezpieczeństwa danego obozu oraz zajęć. Takie obozy będą
                każdorazowo miały wewnętrzny zbiór dodatkowych reguł opisanych w
                programie obozu, za których staranne wykonanie osobiście
                odpowiada Instruktor.
              </li>
              <li>
                Przygotowanie grupy do pokazu organizowanego na koniec Campu.
              </li>
              <li>
                Dążenie do osiągnięcia wszystkich celów dydaktycznych opisanych
                w programie.
              </li>
              <li>Wykonywanie poleceń Kierownika wypoczynku.</li>
            </ol>

            <h3 align="center">§4 Obowiązki osoby wykonującej fotorelacje</h3>
            <ol>
              <li>
                Niezwłoczne zgłaszanie kierownikowi Campu wszelkich
                spostrzeżonych braków i błędów w wyposażeniu, urządzeniach
                technicznych, instalacji, szczególnie tych zagrażających zdrowiu
                i życiu dzieci.
              </li>
              <li>
                Przygotowanie własnego stanowiska pracy na początku turnusu –
                sprawdzenie sprzętu.
              </li>
              <li>
                Wykonywanie zadań w oparciu o dążenie do pełnej akceptacji i
                aktywizacji uczestników.
              </li>
              <li>
                Dbałość o powierzony sprzęt i opiekowanie się nim zgodnie z
                zaleceniami kierownika.
              </li>
              <li>
                Codzienne wykonywanie tylu zdjęć, by co najmniej 250 z danego
                dnia było dobrej jakości i znalazło się na stronie www
                organizatora.
              </li>
              <li>
                W miarę możliwości fotografowanie codziennie każdych zajęć
                programowych, ogólnocampowych i grupowych.
              </li>
              <li>
                Wykonywanie zdjęć podczas: wybranych posiłków, wydarzeń
                specjalnych, zbiórek, ciszy poobiedniej, wycieczek, podróży na
                zajęcia.
              </li>
              <li>
                Drugiego dnia lub najpóźniej trzeciego dnia sfotografowanie
                plakatów na drzwiach pokoi.
              </li>
              <li>
                Przeprowadzenie i nagranie co najmniej 5 wywiadów z dziećmi.
              </li>
              <li>
                Nagranie na koniec turnusu zdjęć na pendrive zgodnie z listą
                przekazaną przez Kierownika.
              </li>
              <li>
                Sprawowanie opieki nad uczestnikami w zakresie ich
                bezpieczeństwa, wyglądu, zdrowia i wychowania.
              </li>
              <li>Wykonywanie poleceń Kierownika wypoczynku.</li>
            </ol>

            <h3 align="center">§5 Obowiązki osoby- pomoc techniczna</h3>
            <ol>
              <li>
                Znajomość i systematyczne przestrzeganie zasad oraz przepisów
                bezpieczeństwa i higieny pracy.
              </li>
              <li>
                Znajomość wszystkich dokumentów obowiązujących podczas
                wypoczynku (regulaminy, przepisy, zarządzenia, instrukcje, plan
                pracy, standardy firmy) oraz stosowanie się do nich.
              </li>
              <li>Sumienne i rzetelne wykonywanie pracy.</li>
              <li>
                Pomoc w organizacji zajęć ogólnocampowych, sportowych,
                rekreacyjnych, programowych oraz wydarzeń specjalnych itd., w
                zakresie:
                <ol type="A">
                  <li>
                    przygotowania sprzętu (np. na dyskotekę, na ognisko, na
                    koncert, na zajęcia programowe)
                  </li>
                  <li>
                    wykonania niezbędnych zakupów i na bieżąco przekazywania
                    faktur VAT i rozliczeń kierownikowi wypoczynku
                  </li>
                  <li>przygotowania sali do zajęć</li>
                  <li>
                    przygotowania gier i zabaw (np. toru przeszkód, podchodów)
                  </li>
                  <li>
                    nadzór nad prawidłowym korzystaniem ze sprzętu przez dzieci
                  </li>
                </ol>
              </li>
              <li>
                Kontrola wyposażenia i stanu urządzeń technicznych, instalacji,
                sprzętu.
              </li>
              <li>
                Opieka nad sprzętem kolonijnym, przeliczenie go na koniec
                turnusu oraz każdorazowo na polecenie kierownika.
              </li>
              <li>Pomoc w odprowadzaniu lub dowożeniu dzieci na zajęcia.</li>
              <li>
                Pomoc w sprawowaniu opieki nad uczestnikami i uczestniczkami w
                zakresie ich bezpieczeństwa, wyglądu, higieny, zdrowia i
                wychowania.
                <ol>
                  <li>
                    Kontrola zaopatrzenia uczestników w odpowiednią odzież i
                    sprzęt zapewniający bezpieczeństwo w czasie realizacji zajęć
                    i kąpieli.
                  </li>
                  <li>
                    Usunięcie wszelkich dostrzeżonych braków i usterek, jeżeli
                    usunięcie ich we własnym zakresie jest możliwe. Niezwłoczne
                    zgłaszanie kierownikowi Campu wszelkich spostrzeżonych
                    braków i błędów zagrażających zdrowiu i życiu dzieci.
                  </li>
                  <li>
                    Natychmiastowe przerwanie zajęć, gdy stan terenu, budynku,
                    pomieszczenia, sprzętu, instalacji, materiału zagraża
                    uczestnikom, pracownikom lub innym osobom.
                  </li>
                  <li>
                    Kontrola przestrzegania przez uczestników obowiązujących
                    regulaminów zajęć, zachowania, oraz nadzór i czujność
                    podczas podróży, zajęć, ćwiczeń, wycieczek, kąpieli i
                    plażowania.
                  </li>
                  <li>
                    Obserwowanie czy nie jest naruszana cielesność dziecka
                    (przemoc fizyczna – bicie, szczypanie, szturchanie;
                    dotykanie przez innych, gdy nie wyraża na to zgody).
                  </li>
                  <li>
                    Interwencja w przypadku zgłoszenia wystąpienia przemocy
                    psychicznej lub fizycznej.
                  </li>
                  <li>
                    Natychmiastowe udzielenie lub zapewnienie uczestnikowi
                    pierwszej pomocy i dalszej opieki w razie nieszczęśliwego
                    wypadku, powiadomienie o wypadku kierownika/kierowniczkę
                    wypoczynku, przeciwdziałanie ujemnym skutkom wypadku i
                    podjęcie innych niezbędnych środków.
                  </li>
                  <li>
                    Przeciwdziałanie dyskryminacji ze względu na płeć, wiek,
                    niepełnosprawność, rasę lub pochodzenie etniczne, wyznanie.
                  </li>
                </ol>
              </li>
              <li>
                Współdziałanie z kadrą w zakresie realizacji programu i
                wykonywania swoich zadań.
              </li>
              <li>
                Pomoc prowadzącym zajęcia programowe w zakresie organizacji i
                realizacji programu oraz w dbaniu o porządek i dyscyplinę.
              </li>
              <li>
                Podczas zajęć wieczornych, ogólnocampowych: pomoc w organizacji,
                dbanie o porządek i dyscyplinę, stosowanie się do uwag i poleceń
                osób prowadzących dane zajęcia, aktywne uczestnictwo od początku
                do końca ich trwania.
              </li>
              <li>
                Informowanie kierownika wypoczynku o wszystkich nadzwyczajnych
                wydarzeniach i obserwacjach.
              </li>
              <li>
                Aktywny udział we wszystkich aktywnościach obozowych (w ramach
                wyznaczonych obowiązków).
              </li>
              <li>
                W razie potrzeby udzielenie pierwszej pomocy podopiecznym lub
                współpracownikom oraz powiadomienia odpowiednich służb.
              </li>
              <li>
                Na polecenie Organizatora uczestniczenie w transporcie grup i
                odpowiadanie za bezpieczeństwo dzieci podczas przewozu. Zasady
                opieki podczas transportu określa osobny dokument – Wytyczne dla
                Kadry Przewozowej.
              </li>
              <li>
                Zachowanie wysokiej kultury osobistej i kultury słowa. Bycie
                wzorem naśladowania dla uczestników obozu.
              </li>
              <li>Wykonywanie poleceń Kierownika wypoczynku.</li>
            </ol>
            <p>Przyjąłem do wiadomości i ścisłego przestrzegania</p>
            <div style="display: flex; justify-content: space-between">
              <div>
                <span>{{ aktualnaData() }}</span>
                <br />
                <span style="margin-left: 0%">Data</span>
              </div>
              <div>
                {{ imieNazwisko }}
                <br />
                <span style="margin-left: 0%">Czytelny podpis</span>
              </div>
            </div>

            <div style="page-break-before: always">
              <h3 align="center">
                Deklaracja w sprawie ochrony zdrowia i życia dzieci oraz
                młodzieży na obozach Music &amp; More
              </h3>
              <p>
                W poczuciu pełnej osobistej odpowiedzialności przed własnym
                sumieniem, rodzicami i społeczeństwem, za bezpieczeństwo,
                zdrowie i życie powierzonych mej opiece dzieci oraz młodzieży na
                obozie/ obozach Music &amp; More, oświadczam, co następuje:
              </p>
              <ol>
                <li>
                  Z należytą uwagą i zrozumieniem zapoznałem/am się ze
                  wszystkimi dokumentami i przepisami dotyczącymi
                  bezpieczeństwa, zdrowia i życia dzieci oraz młodzieży na
                  obozie Music &amp; More.
                </li>
                <li>
                  Z należytą uwagą i zrozumieniem zapoznałem/am się z zakresem
                  obowiązków, odpowiedzialności i uprawnień oraz wytycznymi i
                  standardami dedykowanymi dla powierzonej mi funkcji.
                </li>
                <li>
                  Zobowiązuję się do rzetelnego przestrzegania i stosowania
                  zawartych w dokumentach, przepisach, wytycznych i standardach
                  wskazówek, zaleceń i zarządzeń.
                </li>
                <li>
                  Zobowiązuje się do nie ujawniania poufnych informacji
                  osobistych, z którymi mogę się zetknąć w czasie pełnienia
                  obowiązków na turnusie.
                </li>
              </ol>
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 15px;
                "
              >
                <div>
                  <span>{{ aktualnaData() }}</span>
                  <br />
                  <span style="margin-left: 0%">Data</span>
                </div>
                <div>
                  {{ imieNazwisko }}
                  <br />
                  <span style="margin-left: 0%">Czytelny podpis</span>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
</template>

<script>
export default {
  name: "RegulaminKolonie2023",
  props: {},
  data() {
    return {
      imieNazwisko: "",
    };
  },
  created() {
    Object.entries(this.$route.query).forEach(([key, value]) => {
      this[key] = value;
    });
  },
  methods: {},
  mounted() {
    if (this.imieNazwisko) {
      this.$nextTick(() => {
        window.setTimeout(() => window.print(), 300);
      });
    }
  },
  methods: {
    aktualnaData() {
      const today = new Date();
      let month = today.getMonth() + 1;
      if (today.getMonth() + 1 <= 10) {
        month = "0" + month;
      }
      const todayDate =
        today.getDate() + "-" + month + "-" + today.getFullYear();
      return todayDate;
    },
  },
};
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table,
th,
td {
  border: 1px;
  border-collapse: collapse;
}

h3 {
  margin-top: 3px;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/RegulaminKolonie2023.vue